export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '番茄视频是否需要注册才能观看？',
    answer: '番茄视频大部分内容支持免注册免费在线观看。注册会员后可享受更高画质、去广告、离线缓存等更多特权功能。',
  },
  {
    question: '番茄视频支持哪些设备观看？',
    answer: '番茄视频全面支持电脑网页端、手机移动端（iOS和Android）、平板电脑以及智能电视等主流设备，随时随地畅享高清影视内容。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '番茄视频采用智能CDN加速技术和自适应码率算法，可根据您的网络状况自动调整画质。如遇卡顿，建议检查网络连接或手动切换至较低画质档位。',
  },
  {
    question: '番茄视频的影视资源更新频率如何？',
    answer: '番茄视频每日更新海量影视内容，热门电影和电视剧将在首播后24小时内上线，综艺节目同步跟播，确保您不错过任何精彩内容。',
  },
  {
    question: '番茄视频支持哪些画质？',
    answer: '番茄视频提供流畅、标清、高清720P、全高清1080P和超清4K等多种画质选择，满足不同设备和网络环境下的观影需求。',
  },
  {
    question: '可以在番茄视频上找到老电影吗？',
    answer: '当然可以！番茄视频拥有丰富的经典影片库，涵盖了从上世纪经典到近年佳作的各类影视资源，珍稀老片也能在这里找到高清修复版本。',
  },
  {
    question: '番茄视频是否支持离线下载？',
    answer: '注册会员可享受离线下载功能，将喜欢的影片提前下载到本地，在没有网络的环境下也能畅快追剧。',
  },
  {
    question: '如何向番茄视频反馈问题或建议？',
    answer: '您可以通过网站底部的"联系我们"板块发送反馈信息，或发送邮件至客服邮箱，我们的团队会在24小时内回复您的来信。',
  },
];